import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Pagination } from "../../../../../../../common/pagination";
import ModernPagination from "../../../../../../../common/pagination/ModernPagination";
import Heading from '../../../../../../../common/element/Heading';
import ClientInput from "../../../../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../../../../redux/Admin/breadcrumbsSlice";
import { useDispatch, useSelector } from 'react-redux';
import ToolManagmentCard from "../../../../../../../common/element/Card/ToolManagmnetCard";
import InterViewCandidateList from './InterViewCandidateList';
import AddQuotaModal from './AddQuota';
import AddCandidate from './AddCandidate';
import { selectUserData } from '../../../../../../../redux/auth/authSelector';
import { getInterviewCandidateList, clearCandidateList } from '../../../../../../../redux/InterViewCandidate/interViewCandidateSlice';
import {
    selectCandidateList,
    selectCandidateListLoading,
    selectCandidateListPagination,
    selectCandidateListState
} from '../../../../../../../redux/InterViewCandidate/interViewSelector';
import { useParams, useSearchParams } from 'react-router-dom';

const InterViewCandidate = ({ companyData }) => {
    const dispatch = useDispatch();

    const [searchParams] = useSearchParams();

    // Fetch companyId from route query param
    const companyId = searchParams.get("companyId");
    console.log(companyId, "companyId")
    const [filterpage, setfilterpage] = useState(1);
    const [filterlimit, setfilterlimit] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isOpen, setisOpen] = useState(false);
    const [candidateDialogOpen, setCandidateDialogOpen] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState(null);

    const userData = useSelector(selectUserData);
    const userRole = userData?.role_name;

    const storedCompanyName = useSelector((state) => state.companyView?.companyName);

    // Redux selectors for candidate list
    const candidateListState = useSelector(selectCandidateListState);
    const candidateList = useSelector(selectCandidateList);
    const isLoading = useSelector(selectCandidateListLoading);
    const pagination = useSelector(selectCandidateListPagination);

    // Extract quota information from the state
    const quota = candidateListState?.quota || { total_quota: 0, used_quota: 0 };
    const totalPages = pagination?.totalPages || candidateListState?.totalPages || 1;
    const totalCount = pagination?.total || candidateListState?.total || 0;

    const hasSetBreadcrumbs = useRef(false);

    // Fetch candidate list
    const fetchCandidateList = useCallback(() => {
        const params = {
            company_id: companyId, // Add company ID
            page: filterpage,
            limit: filterlimit,
            search: searchValue,
        };

        console.log("📡 Fetching candidate list with params:", params);
        dispatch(getInterviewCandidateList(params));
    }, [dispatch, companyId, filterpage, filterlimit, searchValue]);

    // Initial fetch and refetch on filter changes
    useEffect(() => {
        fetchCandidateList();
    }, [fetchCandidateList]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            dispatch(clearCandidateList());
        };
    }, [dispatch]);

    // Search handler with debounce
    const handleSearch = (e) => {
        setSearchValue(e.target.value.trim());
        setfilterpage(1); // Reset to first page on search
    };

    const inputchangehandler = useCallback(debounce(handleSearch, 500), []);
    console.log(quota, "quotaquotaquota")
    useEffect(() => {
        if (hasSetBreadcrumbs.current) return;

        let crumbs = [];

        if (userRole === "HR" || userRole === "Adhoc HR" || userRole === "Company Admin" || userRole === "Management" || userRole === "Science Of Self" || userRole === "Sales Training Company" ) {
            crumbs = [
                {
                    label: "Interview Candidate",
                    url: "/interViewCandidate",
                    home: "/interViewCandidate"
                },
            ];
        } else {
            const companyLabel = companyData?.company_name || storedCompanyName || 'View Company';
            crumbs = [
                {
                    label: "Companies",
                    url: "/companies",
                    home: "/companies",
                },
                {
                    label: companyLabel,
                    url: "/companies/view",
                }
            ];
        }

        dispatch(setBreadcrumbs(crumbs));
        hasSetBreadcrumbs.current = true;
    }, [dispatch, userRole]);

    const handlePageChange = (page) => {
        setfilterpage(page);
    };

    const handleView = (batch) => {
        console.log("view batch", batch);
    };

    const handleEdit = (batch) => {
        setSelectedBatch(batch);
        setIsEdit(true);
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setSelectedBatch(null);
        setIsEdit(false);
    };

    const handleAddCandidate = () => {
        setSelectedCandidate(null);
        setCandidateDialogOpen(true);
    };

    const handleCandidateDialogClose = () => {
        setCandidateDialogOpen(false);
        setSelectedCandidate(null);
    };

    // Callback to refresh list after adding candidate or quota
    const handleRefreshList = () => {
        fetchCandidateList();
    };

    // Handle quota modal close with refresh
    const handleQuotaModalClose = () => {
        setisOpen(false);
        fetchCandidateList(); // Refresh to get updated quota
    };

    // Handle candidate modal close with refresh
    const handleCandidateModalClose = () => {
        setCandidateDialogOpen(false);
        setSelectedCandidate(null);
        fetchCandidateList(); // Refresh to get updated list
    };

    // Conditional wrapper component
    const ContentWrapper = userRole === "Admin" ? ToolManagmentCard : React.Fragment;

    return (
        <React.Fragment>
            <div>
                <p className="text-gray-600 my-3"></p>
            </div>

            <ContentWrapper>
                {userRole === "Admin" ? (
                    <>

                        <div className="flex justify-between items-center">
                            <p className="text-start text-[16px] font-semibold mb-4">
                                Interview Candidates
                            </p>
                            {companyData?.company_isActive &&
                                <div className="input-wrapper mb-4 ">
                                    <div className="flex gap-2 items-center">
                                        <BtnPrimary
                                            onClick={() => setisOpen(true)}
                                            className="text-xs h-9 flex items-center justify-center gap-1 px-1"
                                        >
                                            {(candidateList.length || quota?.total_quota !== 0) ? "Edit Quota" : "Add Quota"}
                                            <svg
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M10.712 4.167v11.666M4.878 10h11.667"
                                                    stroke="#fff"
                                                    strokeWidth="1.667"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </BtnPrimary>

                                        <BtnPrimary
                                            onClick={handleAddCandidate}
                                            className="text-xs h-9 flex items-center justify-center px-3 gap-1 whitespace-nowrap"
                                        >
                                            Add Candidate
                                            <svg
                                                width="21"
                                                height="20"
                                                viewBox="0 0 21 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M10.712 4.167v11.666M4.878 10h11.667"
                                                    stroke="#fff"
                                                    strokeWidth="1.667"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </BtnPrimary>

                                        <h4 className="font-semibold whitespace-nowrap flex-shrink-0">
                                            Quota: {quota.used_quota}/{quota.total_quota}
                                        </h4>

                                    </div>
                                </div>}
                        </div>


                        <div className="gap-y-4 border-t border-gray-200 py-2"></div>

                        <div className="flex justify-end mb-4">
                            <div className="input-wrapper">
                                <div className="input-suffix-start left-3.5">
                                    <img
                                        src="/assets/icons-svg/search-lg.svg"
                                        alt=""
                                        className="h-5"
                                    />
                                </div>
                                <ClientInput
                                    type="text"
                                    className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="Search by name or email"
                                    inputchangehandler={inputchangehandler}
                                    name={"search"}
                                />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex justify-between mb-3">
                            <div className="h-10 text-start">
                                <Heading>Interview Candidate</Heading>
                            </div>

                            <div className="flex justify-end">
                                {((userRole === "HR" || userRole === "Adhoc HR" || userRole === "Company Admin" || userRole === "Management" || userRole === "Science Of Self" || userRole === "Sales Training Company" ) ? userData?.company_isActive : true) && (
                                    <BtnPrimary
                                        onClick={handleAddCandidate}
                                        className="text-xs h-9 flex items-center justify-center px-3 gap-1 whitespace-nowrap"
                                    >
                                        Add Candidate
                                        <svg
                                            width="21"
                                            height="20"
                                            viewBox="0 0 21 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M10.712 4.167v11.666M4.878 10h11.667"
                                                stroke="#fff"
                                                strokeWidth="1.667"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </BtnPrimary>
                                )}
                            </div>
                        </div>
                        <div className='flex justify-end mb-2 items-center'>
                            <div className="input-wrapper mx-3">
                                <div className="input-suffix-start left-3.5">
                                    <img
                                        src="/assets/icons-svg/search-lg.svg"
                                        alt=""
                                        className="h-5"
                                    />
                                </div>
                                <ClientInput
                                    type="text"
                                    className="input pl-10 w-80 input-shadow h-10 text-sm border-gray-300 rounded-lg appearance-none border text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    placeholder="Search"
                                    inputchangehandler={inputchangehandler}
                                    name={"search"}
                                />
                            </div>
                            <p className="font-medium text-[14px] leading-[150%] tracking-[0%] text-[#475467] whitespace-nowrap flex-shrink-0">
                                Quota: {quota.used_quota}/{quota.total_quota}
                            </p>

                        </div>
                    </>
                )}

                <InterViewCandidateList
                    companyData={companyData}
                    sampleData={candidateList}
                    onView={handleView}
                    onEdit={handleEdit}
                    isLoading={isLoading}
                    onRefresh={handleRefreshList}
                    currentPage={filterpage}    // ✅ Add this
                    pageLimit={filterlimit}     // ✅ Add this
                />

                <div className="flex justify-between items-center mt-3">
                    <Pagination
                        totalCount={totalCount}
                        pageNumber={filterpage}
                        displayPage={candidateList?.length || 0}
                        UpdatePageLimit={setfilterlimit}
                        UpdatePage={setfilterpage}
                    />

                    {totalCount > 0 && totalPages > 1 && (
                        <ModernPagination
                            totalPages={totalPages}
                            currentPage={filterpage}
                            onPageChange={handlePageChange}
                        />
                    )}
                </div>
            </ContentWrapper>

            <AddQuotaModal
                dialogOpen={isOpen}
                onDialogClose={handleQuotaModalClose}
                onSubmit={handleRefreshList}
                companyId={companyId}
                candidateList={candidateList}
                quota={quota}
            />

            <AddCandidate
                dialogOpen={candidateDialogOpen}
                onDialogClose={handleCandidateModalClose}
                candidateData={selectedCandidate}
                companyId={companyId}
                onSuccess={handleRefreshList}
            />
        </React.Fragment>
    )
}

export default InterViewCandidate;